import { SUPERADMIN_ROLE } from './guards';

export function buildDeleteChallenge(emails: string[]): string {
  if (emails.length === 0) return '';
  if (emails.length === 1) return emails[0]!;
  return `EXCLUIR ${emails.length} USUÁRIOS`;
}

export function canPurgeOrgMember(opts: {
  memberId: string;
  targetOwnerId: string;
  memberGlobalRole: string | null | undefined;
  ownsOtherOrgs: boolean;
}): boolean {
  if (opts.memberId === opts.targetOwnerId) return false;
  if (opts.memberGlobalRole === SUPERADMIN_ROLE) return false;
  if (opts.ownsOtherOrgs) return false;
  return true;
}
